'use client';
import { useState, useEffect, startTransition } from 'react';
import { detectIncognito } from 'detectincognitojs';

export const useDetectIncognitoMode = () => {
  const [isIncognito, setIsIncognito] = useState<boolean | null>(null);

  useEffect(() => {
    detectIncognito().then(result => {
      startTransition(() => {
        setIsIncognito(result.isPrivate);
      });
    });
  }, []);

  return isIncognito;
};
